export default __webpack_public_path__ + "static/conf-2018-51c4817f40e9499c586562ba86e5ce33.png";